<template>
  <div class='lib__field' style='margin-bottom: 20px;'>
    <div class='lib__field lib__field--checkbox'>
      <label class='lib__field__label'>
      <span class='lib__field__label__icon'>
        <img v-if='IsGas' :src="require('@ores/css-library/assets/img/icons/gas.svg')" alt='Gas' />
        <img v-else :src="require('@ores/css-library/assets/img/icons/electricity.svg')" alt='Electricity' />
      </span>
        <span>{{ value.ean }}</span>
      </label>
    </div>
    <div class='lib__card lib__bg-white'>
      <template v-for='(meterInfo, idx) in value.meterInfos'>
        <MeterBox :isGas='IsGas' :value='meterInfo' @input='setMeterValue($event, idx)' />
      </template>
    </div>
  </div>
</template>

<script lang='ts'>
import { Prop, Vue } from 'vue-property-decorator'
import Component from 'vue-class-component'
import MeterBox from '@/components/inputs/ProsumerDeclaration/meter-reading/MeterBox.vue'
import { GridAccessPoint, Meter } from '@/models/prosumer-declaration'
import { EnergyType, TariffType } from '@/models/common'

@Component({
  components: {
    MeterBox,
  },
})
export default class GridAccessPointBox extends Vue {
  @Prop({ required: true }) public readonly value!: GridAccessPoint
  @Prop({ type: Boolean, required: false, default: false }) public readonly onlyIndex!: boolean

  public get IsGas(): boolean {
    return this.EnergyType === EnergyType.gas
  }

  public get EnergyType(): EnergyType {
    return this.value.energyType
  }

  public mounted(): void {
    for (const meter of this.value.meterInfos) {
      if (meter.tariffType === null) {
        meter.tariffType =
          meter.isSimple ? TariffType.Simple :
            meter.isNightExclusive ? TariffType.NightExclusive :
              meter.isDayAndNight ? TariffType.Dual : null
      }
    }
  }

  public setMeterValue(data: Meter, idx: number): void {
    this.value.meterInfos[idx] = data
  }
}
</script>

